export type SearchStats = {
    searchTerm: string;
    searchResults?: number | undefined;
    searchType?: string;
    isSuggestedProduct?: boolean;
};

export const storageSearchedTermKey = 'psLastSearchedTerm';

export const storageSearchStats = 'psLastSearchStats';

// These are kept because they are maintained on Legacy as well.
const getSearchedTerm = (): string => {
    const searchTerms = localStorage.getItem(storageSearchedTermKey);
    return searchTerms ? JSON.parse(searchTerms) : '';
};

const setSearchedTerm = (searchTerm?: string): void => {
    localStorage.setItem(storageSearchedTermKey, JSON.stringify(searchTerm));
};

export const getSearchStats = (): SearchStats => {
    const storageStats = localStorage.getItem(storageSearchStats);
    const searchStats = storageStats
        ? JSON.parse(storageStats)
        : {
              searchType: '',
              searchResults: undefined,
          };

    return {
        ...searchStats,
        searchTerm: getSearchedTerm(),
    };
};

export const setSearchStats = ({
    searchResults,
    searchTerm,
    searchType,
    isSuggestedProduct,
}: SearchStats) => {
    setSearchedTerm(searchTerm);

    localStorage.setItem(
        storageSearchStats,
        JSON.stringify({
            searchResults,
            searchTerm,
            searchType,
            isSuggestedProduct,
        })
    );
};
